var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"userBriefHistory pl-3",class:_vm.$vuetify.theme.dark ? 'transparent ' : 'transparent',attrs:{"tile":"","flat":""}},[_c('banner-upload-tab')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }